/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_TitleInputs */

const en_cc_title = /** @type {(inputs: Cc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng for Google Calendar`)
};

const id_cc_title = /** @type {(inputs: Cc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng untuk Google Calendar`)
};

/**
* | output |
* | --- |
* | "KerjaBareng for Google Calendar" |
*
* @param {Cc_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_title = /** @type {((inputs?: Cc_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_title(inputs)
	return en_cc_title(inputs)
});